export default "__VITE_ASSET__3934a49a__"